export default __webpack_public_path__ + "static/media/circle_3.9c52cb5c.svg";